const _ = require('lodash')

const state = {
    leaguesVisible : {},
};

const mutations = {
    SET_LEAGUE_VIEWS: (state, leagues) => {
        state.leaguesVisible = leagues;
    },
    CHANGE_VISIBILITY: (state, league) => {
        state.leaguesVisible = _.clone(_.assign(state.leaguesVisible, {[league.key]: league.isVisible}))
    },
};

const actions = {
    setLeagueViews({commit}, leagues) {
        return commit('SET_LEAGUE_VIEWS', leagues)
    },
    changeVisibility({commit}, league) {
        return commit('CHANGE_VISIBILITY', league)
    },
};

const getters = {
    visibleLeagues: state => state.leaguesVisible,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};